import { Route, Routes } from 'react-router-dom'
import AboutUs from '../pages/about-us'
import Account from '../pages/account'
import Apply from '../pages/apply'
import AuthRedirect from './AuthRedirect'
import BugReport from '../pages/bug-report'
import ConfirmPassword from '../pages/confirm-password'
import ContactUs from '../pages/contact-us'
import Default from '../pages/default'
import Faq from '../pages/faq'
import ForgotPassword from '../pages/forgot-password'
import { HistoryRouter } from 'redux-first-history/rr6'
import Index from '../pages/index'
import Layout from './Layout'
import Privacy from '../pages/privacy'
import Recs from '../pages/recs'
import SignIn from '../pages/signin'
import SignUp from '../pages/signup'

const Router = ({ history }) => (
  <HistoryRouter history={history}>
    <Routes>
      <Route element={<Layout />} path='/'>
        <Route element={<Index />} index />
        <Route element={<AuthRedirect />} path='__/auth/action' />
        <Route element={<AboutUs />} path='about-us' />
        <Route element={<Account />} path='account' />
        <Route element={<Apply />} path='apply' />
        <Route element={<BugReport />} path='bug-report' />
        <Route element={<ConfirmPassword />} path='confirm-password' />
        <Route element={<ContactUs />} path='contact-us' />
        <Route element={<Faq />} path='faq' />
        <Route element={<ForgotPassword />} path='forgot-password' />
        <Route element={<Privacy />} path='privacy' />
        <Route element={<Recs />} path='recs' />
        <Route element={<SignIn />} path='signin' />
        <Route element={<SignUp />} path='signup' />
        <Route element={<Default />} path=':dir' />
        <Route element={<Default />} path=':dir/:page' />
        <Route element={<Default />} path=':dir/:page/:subpage' />
      </Route>
    </Routes>
  </HistoryRouter>
)

export default Router
